































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class PolaTidurSection extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: any;
  @Prop({ default: false }) readonly disabled!: boolean;

  form: any = {
    tidur_malam_lama: null,
    tidur_malam_pukul: "",
    tidur_siang: "kadang",
    tidur_siang_lama: null,
    merokok: false,
    alkohol: false
  };

  created() {
    if (this.value && typeof this.value === "object") {
      this.form = { ...this.form, ...this.value };
    }
  }


  @Watch("form", { deep: true })
  onFormChange(val: any) { this.$emit("input", { ...val }); }

  syncFromValue(val: any) {
    if (!val) return;
    this.form = { ...this.form, ...val };
  }
}
